import React from 'react';

import type { Section } from '../../../../../models';
import UtilitiesCalculation from './UtilitiesCalculation';
import { WATER_SEWER, WATER_SEWER_UTILITY_CALCULATION_LISTBOX_OPTIONS } from '../../../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function WaterSewerCalculation({ section, setSectionValues }: Props): JSX.Element {
  return (
    <UtilitiesCalculation
      section={section}
      setSectionValues={setSectionValues}
      administrativeFeeField={WATER_SEWER.FIELD_NAME.ADMINSTRATIVE_FEE}
      listBoxField={WATER_SEWER.FIELD_NAME.FIXED_AMOUNT_CALCULATION}
      otherMethodDescriptionField={WATER_SEWER.FIELD_NAME.OTHER_METHOD_DESCRIPTION}
      otherMethodField={WATER_SEWER.FIELD_NAME.OTHER_METHOD}
      options={WATER_SEWER_UTILITY_CALCULATION_LISTBOX_OPTIONS}
      utilityName="Water/sewer"
    />
  );
}

WaterSewerCalculation.description =
  'Additional options for how they calculated and whether or not there an additional fee';

export default WaterSewerCalculation;
